export default "__VITE_ASSET___ccCyF0T__"